import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { Copy } from "../Copy";

interface AccountItemProps {
  username: string;
  icon: string;
  address?: string;
  isCopy?: boolean;
  className?: string;
  onUnlink?: () => void;
}

export const AccountItem = ({
  username,
  icon,
  address,
  isCopy = false,
  className,
  onUnlink,
}: AccountItemProps) => {
  return (
    <div
      className={cn(
        "flex w-full max-w-[340px] justify-between items-center p-4 rounded-lg bg-background_white_overlay5",
        className,
      )}
    >
      <div className="flex items-center gap-3">
        <div className="flex items-center w-8 h-8 rounded-lg bg-background_white_overlay10 justify-center">
          <Icon name={icon} className="text-content_primary/70" size={16} />
        </div>
        <div className="flex items-center gap-1">
          <div className="body_medium_m text-content_secondary">{username}</div>
          {isCopy && (
            <Copy
              text={address ?? ""}
              iconSize={12}
              className="xs_button_icon"
            />
          )}
        </div>
      </div>
      <Icon
        data-openreplay-label="unlink"
        name="unlink"
        className="xs_button_icon text-content_tertiary cursor-pointer"
        size={12}
        onClick={onUnlink}
      />
    </div>
  );
};
